const icons = {
    down: require("../assets/icons/down.png"),
    right: require("../assets/icons/right.png"),
    left: require("../assets/icons/left.png"),
    search: require("../assets/icons/search.png"),
    menu: require("../assets/icons/menu.png"),
    play: require("../assets/icons/play.png"),
    user: require("../assets/icons/user.png"),
    close: require("../assets/icons/close.png"),
};

export default icons;
